<ng-container>
	<div class="white-text">{{ displayedVersion }}</div>
</ng-container>

